import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((value) => {
        if (
            !window.location.href.includes('login') &&
            !window.location.href.includes('dashboard') &&
            !window.location.href.includes('sso-error') &&
            !window.location.href.includes('auth')
        ) {
            localStorage.setItem('initialUrl', window.location.pathname.toString());
        } else {
            localStorage.removeItem('initialUrl');
        }
    })
    .catch((err) => console.error(err));
